import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

const StatusToken = ({ status, value }) => {
  const val = (status || value)
  if(!val) return null
  return (
    <div className={`maha-status-token ${val.replace('-','')}`}>
      <div className="maha-status-token-icon">
        <Icon icon="circle" />
      </div>
      <div className="maha-status-token-details">
        { _.startCase(val.replace('-','')) }
      </div>
    </div>
  )
}

StatusToken.propTypes = {
  status: PropTypes.string,
  value: PropTypes.string
}

export default StatusToken
